/**
 * PaymenMethodEnum
 */
export enum PaymenMethodEnum {
  CARD = "card",
  CREDIT_CARD = "credit_card",
  DEBIT_CARD = "debit_card",
  TRANSFER = "transfer",
  CASH = "cash",
  PAYOUTS_CASH = "payouts_cash",
  CARD_ASYNC = "card_async",
  CARD_SUBSCRIPTION_ASYNC = "card_subscription_async",
  CARD_DYNAMIC = "card_dynamic",
  TRANSFER_SUBSCRIPTION = "transfer_subscription",
  CARD_SUBSCRIPTION_DYNAMIC = "card_subscription_dynamic",
}



// WEBPACK FOOTER //
// ./src/shared/PaymenMethodEnum.ts